// Vendors
import React, { lazy } from 'react';

const ContractContainer = lazy(() => import('containers/contract/contract.container'));
const GetStateContainer = lazy(() => import('containers/get-state/get-state.container'));
const KycContainer = lazy(() => import('containers/kyc/kyc.container'));
const PaymentContainer = lazy(() => import('containers/payment/payment.container'));
const ProofIncomeContainer = lazy(() => import('containers/proof-income/proof-income.container'));
const UploadIdContainer = lazy(() => import('containers/upload-id/upload-id.container'));
const SuccessContainer = lazy(() => import('containers/success/success.container'));
import { ProcessEndedContainer } from 'containers/process-ended/process-ended.container';
// Components
import { EntrypointOrchestratorUncategorizedComponent } from './components/uncategorized/entrypoint-orchestrator-uncategorized.component';
import { ScrollTopComponent } from 'components/scroll-top/scroll-top.component';
// Hooks
import { useEntrypointOrchestratorHook } from './hooks/entrypoint-orchestrator.hook';
// Utilities
import {
  isContractPage,
  isGetStateLoadingPage,
  isKYCFlowPage,
  isPaymentPage,
  isProofOfIncomePage,
  isProcessEndedPage,
  isThankYouOrPendingPage,
  isUploadIdFlowPage,
} from './utils/entrypoint-orchestrator.utils';

const EntrypointOrchestratorComponent = (): React.JSX.Element => {
  const { currentState } = useEntrypointOrchestratorHook();

  const ComponentToRender =
    {
      [`${isGetStateLoadingPage(currentState)}`]: GetStateContainer,
      [`${isPaymentPage(currentState)}`]: PaymentContainer,
      [`${isProofOfIncomePage(currentState)}`]: ProofIncomeContainer,
      [`${isKYCFlowPage(currentState)}`]: KycContainer,
      [`${isUploadIdFlowPage(currentState)}`]: UploadIdContainer,
      [`${isContractPage(currentState)}`]: ContractContainer,
      [`${isThankYouOrPendingPage(currentState)}`]: SuccessContainer,
      [`${isProcessEndedPage(currentState)}`]: ProcessEndedContainer,
    }['true'] || EntrypointOrchestratorUncategorizedComponent;

  return (
    <>
      <ComponentToRender />
      <ScrollTopComponent state={currentState} />
    </>
  );
};

export { EntrypointOrchestratorComponent };
